import Button from '@material-ui/core/Button'
import { Auth } from 'aws-amplify'
import React, { useState, useRef } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import '../authentication/Login.css'
import styles from './LoginForm.module.css'
import { getQueryParams } from '../authentication/utils'
import InputPassword from './InputPasswordBox'
import PasswordValidations from './PwdValidations'
import { getUserDetails } from '../../actions/homeActions'

function ResetPasswordForm(props) {
  const [verificationCode, setVerification] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [disableSendBtn, setDisableSendBtn] = useState(true)
  const [isReveal, setIsReveal] = useState(true)
  const [isRevealConfirm, setIsRevealConfirm] = useState(true)
  const passwordInput = useRef(null)
  const confirmPasswordInput = useRef(null)
  const togglePassword = id => {
    setIsReveal(prev => !prev)
    var pass = document.getElementById(id)
    if (pass) {
      if (pass.type === 'password') {
        pass.type = 'text'
      } else {
        pass.type = 'password'
      }
    }
  }
  const toggleConfirmPassword = id => {
    setIsRevealConfirm(prev => !prev)
    var pass = document.getElementById(id)
    if (pass) {
      if (pass.type === 'password') {
        pass.type = 'text'
      } else {
        pass.type = 'password'
      }
    }
  }

  const handleKeyUp = e => {
    if (e.keyCode === 9) {
      e.preventDefault()
    }
  }

  const handleConfirmVerification = async e => {
    e.preventDefault()
    console.log('calling reset')
    console.log(props.email)
    console.log(verificationCode)
    console.log(password)
    if (password == confirmPassword) {
      props.toggleLoader(true)
      Auth.completeNewPassword(props.user, password)
        .then(async user => {
          console.log(user)
          
          // Get user email and details
          try {
            const email = user.attributes?.email || user.challengeParam?.userAttributes?.email || props.user.challengeParam?.userAttributes?.email
            console.log('Email after password change:', email)
            
            if (email) {
              // Fetch user details
              const userData = await getUserDetails(email)
              console.log('User data fetched:', userData)
              
              if (userData && userData.data && userData.data.memberIdCardList && userData.data.memberIdCardList.length > 0) {
                // Set localStorage values
                const memberData = userData.data.memberIdCardList[userData.data.memberIdCardList.length - 1]
                const firstMember = userData.data.memberIdCardList[0]
                
                localStorage.setItem('userMail', email)
                localStorage.setItem('cognitoUsername', user.username)
                localStorage.setItem('phone', user.attributes?.phone_number || user.challengeParam?.userAttributes?.phone_number || '')
                localStorage.setItem('subscriberName', `${firstMember.prefix || ""} ${firstMember.firstName || ""} ${firstMember.middleName || ""} ${firstMember.lastName || ""} ${firstMember.suffix || ""}`.trim())
                localStorage.setItem('SOURCE', memberData.source)
                localStorage.setItem('CLIENT_ID', memberData.clientId)
                localStorage.setItem('planId', memberData.planId)
                localStorage.setItem('EMPID', firstMember.empId || '')
                localStorage.setItem('sourceid', firstMember.subscriberId || '')
                
                // Set contact number
                const contact = memberData.planInfo?.find(obj => obj.idcardField == 'contact number')
                localStorage.setItem('CONTACT_NUMBER', contact ? contact.fieldValue : 'NA')
                
                console.log('LocalStorage values set successfully')
              }
            }
          } catch (error) {
            console.error('Error fetching user details:', error)
          }
          
          props.toggleLoader(false)
          let queryParams = getQueryParams()
          console.log(queryParams)
          if (queryParams.u) {
            let userName = decodeURI(queryParams.u)
            let url = window.location.href.split('?')[0] + '?u=' + userName + '&p=' + password
            window.location.replace(url)
          } else {
            window.location.reload()
          }
        })
        .catch(err => {
          props.toggleLoader(false)
          console.log(err.message)
          setErrorMessage(err.message)
        })
    } else {
      setErrorMessage('Please enter same password')
    }
  }

  const handleChange = e => {
    if (e.target.name == 'password') {
      setPassword(e.target.value)
    } else if (e.target.name == 'confirmPassword') {
      setConfirmPassword(e.target.value)
    }
  }
  const toggleResetBtn = allPassed => {
    setDisableSendBtn(!allPassed)
  }

  return (
    <div>
      {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
        <div className="loginformnew">
          <div className={styles.loginform_flex_container}>
            {/* Left Panel: Image and Footer */}
            <div className={styles.loginform_left_panel}>
              <div className={styles.loginform_image_wrapper}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
              </div>
              <div className={styles.loginform_footer}>
                Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                Version 6.1.0
              </div>
            </div>
            {/* Right Panel: Form */}
            <div className={styles.loginform_right_panel}>
              <form onSubmit={handleConfirmVerification} className={styles.loginform_form_wrapper}>
                <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                <div className={styles.login_input_container}>

                  <div className={styles.password_change_header}>
                    <div className={styles.password_change_title}>Change Password</div>
                    <div className={styles.password_change_subtitle}>Please enter your new password below.</div>
                  </div>

                  <div className={styles.login_input_container}>
                    {/* Password input with eye icon toggle, matching LoginForm.js */}
                    <div className={styles.loginform_password_wrapper}>
                      <input
                        className={["login_input_username", styles.loginform_input].join(' ')}
                        id="pass"
                        type="password"
                        placeholder="Enter new password"
                        style={{fontSize:'20px'}}
                        name="password"
                        ref={passwordInput}
                        required
                        onChange={handleChange}
                        onKeyDown={handleKeyUp}
                        value={password}
                      />
                      <span className={["p-viewer", styles.loginform_eye_icon].join(' ')} onClick={() => togglePassword('pass')}>
                        {isReveal ? (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>

                    {/* Confirm password input with eye icon toggle */}
                    <div className={styles.loginform_password_wrapper}>
                      <input
                        className={["login_input_username", styles.loginform_input].join(' ')}
                        id="confirmPass"
                        type="password"
                        placeholder="Enter new password again"
                        style={{fontSize:'20px'}}
                        name="confirmPassword"
                        ref={confirmPasswordInput}
                        required
                        onChange={handleChange}
                        onKeyDown={handleKeyUp}
                        value={confirmPassword}
                      />
                      <span className={["p-viewer", styles.loginform_eye_icon].join(' ')} onClick={() => toggleConfirmPassword('confirmPass')}>
                        {isRevealConfirm ? (
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        ) : (
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        )}
                      </span>
                    </div>

                    {errorMessage.length > 0 && (
                      <div className={styles.login_error_message} style={{marginTop:'-5px'}}>{errorMessage}</div>
                    )}

                    <Button type="submit" className={["login_button", styles.loginform_button].join(' ')} onClick={handleConfirmVerification}>
                      SEND
                    </Button>
                  </div>

                  <div className={styles.password_validations_wrapper}>
                    <PasswordValidations password={password} allPassed={toggleResetBtn} />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="loginmobile">
          {/* <div class="loginmobile_header"> */}
            {/* <div class="loginmobile_header_text">Member Portal</div> */}
          {/* </div> */}

          <div class="loginmobile_container">
            <form>
              <div class="loginmobile_image_container" style={{paddingTop:'30px'}}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} class="loginmobile_banner" />
                <img src={require('../../source/Images/Banner/logo.png')} class="loginmobile_logo" />
              </div>

              <div class="firsttimemobile_bottom_text">
                <div className={styles.password_change_title}>Change Password</div>
                <div className={styles.password_change_subtitle}>
                  <div>Please enter your new passsword below.</div>
                </div>
              </div>

              <div class="loginmobile_input_container">
                <div class="mobile-linput"></div>
                <div style={{ position: 'relative', marginBottom: '15px' }}>
                  <input
                    type="password"
                    id="passMobile"
                    placeholder="Enter new password"
                    name="password"
                    ref={passwordInput}
                    required
                    onChange={handleChange}
                    className="login_input_username"
                    value={password}
                  />
                  <span className="p-viewer-mob" onClick={() => togglePassword('passMobile')} style={{right:'-20px'}}>
                    {isReveal ? (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    )}
                  </span>
                </div>

                <div style={{ position: 'relative', marginBottom: '15px' }}>
                  <input
                    type="password"
                    id="confirmPassMobile"
                    placeholder="Enter new password again"
                    name="confirmPassword"
                    ref={confirmPasswordInput}
                    required
                    onChange={handleChange}
                    className="login_input_username"
                    value={confirmPassword}
                  />
                  <span className="p-viewer-mob" onClick={() => toggleConfirmPassword('confirmPassMobile')} style={{right:'-20px'}}>
                    {isRevealConfirm ? (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    )}
                  </span>
                </div>
                <p className={styles.login_error_message} hidden={errorMessage.length <= 0} style={{ paddingBottom: '13px' }}>
                  {errorMessage}
                </p>


                <Button type="submit" variant="contained" color="" style={{marginTop:'0px'}} class="loginmobile_button" onClick={handleConfirmVerification}>
                  SEND
                </Button>
              </div>

              <div className="mt-3 passowrd_validation_center">
                <PasswordValidations password={password} allPassed={toggleResetBtn} />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResetPasswordForm
